<template>
    <div class="container-fluid p-3" :class="{loading: loading.data}">
        <div class="row">
            <span class="title d-flex align-items-center">
                <inline-svg class="me-2" width="36" height="36" src="/assets/img/icons/home-line.svg"></inline-svg>
                Home
            </span>
        </div>
        <div class="row mt-2">
            <div class="col-8">
                <milestones-list :milestones="milestones"></milestones-list>
            </div>
            <div class="col-4 team-card">
                <div class="section-title mb-1">My Heroes</div>
                <router-link :to="{ name: 'hero.details', params: {hero_id: hero.id}}" class="dashboard-hero-card" v-for="hero in heroes">
                    <div class="dashboard-hero-card__title w-100 d-flex flex-row justify-content-between">
                        <span>{{hero.name}} • Today</span>
                        <inline-svg src="/assets/img/icons/right-arrow.svg"></inline-svg>
                    </div>
                    <div class="dashboard-hero-card__task" v-if="hero.today_tasks_count">{{hero.today_tasks_count}} {{hero.today_tasks_count === 1 ? 'activity' : 'activities'}}</div>
                    <div class="dashboard-hero-card__no-task" v-else>No Scheduled Activities</div>
                </router-link>
                <router-link style="text-decoration: none" :to="{name: 'heroes'}" v-if="heroes.length > 1">See all</router-link>
                <div v-if="!heroes.length">
                    <btn class="btn-outline-primary w-100" @click="$router.push({name: 'heroes'})">
                        <inline-svg class="me-1" src="/assets/img/icons/plus.svg"></inline-svg>
                        Add New Hero
                    </btn>
                </div>

                <div class="section-title mb-1 mt-3">My Teams</div>
                <tabs v-if="heroes && heroes.length">
                    <tab :name="hero.name" v-for="hero in heroes">
                        <div class="team-row">
                            <span class="fw-bold">Family&Friends</span>
                            <a @click.prevent="redirectToAddCaregiver(hero.id)" class="card-link link-primary" href="#">Add</a>
                        </div>
                        <div v-if="hero.caregivers && hero.caregivers.length">
                            <user-avatar v-for="caregiver in hero.caregivers"
                                         class="mt-2"
                                         :user="caregiver"
                                         displayName="true"
                                         :subtitle="caregiver.pivot.team_member_profession">
                            </user-avatar>
                        </div>
                        <div v-else class="team-card-small">
                            <span class="dashboard-card-description">There are no Caregivers in this Hero's network!</span>
                        </div>
                        <div class="team-row">
                            <span class="fw-bold">Professionals</span>
                            <a @click.prevent="redirectToAddCaregiver(hero.id)" class="card-link link-primary" href="#">Add</a>
                        </div>
                        <div v-if="hero.professionals && hero.professionals.length">
                            <user-avatar v-for="professional in hero.professionals"
                                         class="mt-2"
                                         :user="professional"
                                         displayName="true"
                                         :subtitle="professional.pivot.team_member_profession">
                            </user-avatar>
                        </div>
                        <div v-else class="team-card-small">
                            <span class="dashboard-card-description">There are no professionals in this Hero's network!</span>
                        </div>
                    </tab>
                </tabs>
                <div v-else>
                    <btn class="btn-outline-primary w-100" @click="$router.push({name: 'heroes'})">
                        <inline-svg class="me-1" src="/assets/img/icons/plus.svg"></inline-svg>
                        Add New Team
                    </btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import UserAvatar from "@/components/UserAvatar.vue";
import MilestonesList from "@/components/MilestonesList.vue";
import Tabs from "@/components/core/Tabs.vue";
import Tab from "@/components/core/Tab.vue";

export default {
  name: 'Dashboard',
  components: {Tab, Tabs, MilestonesList, UserAvatar},
  data() {
    return {
      loading: {
        data: false,
      },
      milestones: [
        {}
      ],
      heroes: [],
    };
  },
  mounted() {
    this.getMyHeroes();
  },
  methods: {
    getMyHeroes() {
      let currentDayStart = new Date();
      currentDayStart.setHours(0,0,0,0);
      let currentDayEnd = new Date();
      currentDayEnd.setHours(24,0,0,0)
      this.loading.data = true;
      this.$http.post("/dashboard/my-heroes", {'date_from': currentDayStart, 'date_to': currentDayEnd})
        .then((res) => {
          this.heroes = res.body.data;
          this.loading.data = false;
        })
        .catch((error) => {
          this.loading.data = false;
        });
    },
    redirectToAddCaregiver(hero_id) {
      this.$router.push({name: 'hero.details', params: {hero_id: hero_id, addTeamMember: true}});
    },
  }
};
</script>
